export default __webpack_public_path__ + "static/media/url.2023bcc9.png";